import { Salon } from "reducers/salon";

export const isSalonSaas = (salon: Salon): boolean => {
  if (!salon || !salon.partnerRefs || !salon.partnerRefs.length) {
    return false;
  }
  return salon.partnerRefs.findIndex(({ name }) => name === "flexy") !== -1;
};
